module.exports = __webpack_public_path__ + "img/spiral-details17.410288c5.png";